"use strict";

// Show loginCtn when confirmBtn is clicked
$(document).on("click", ".wishlistModalConfirm", function () {
    $(".modalBody").hide();
    $(".loginCtn").show();
});

// Hide backgroundCtn on cancelBtn or crossBtn click
$(document).on("click", ".wishlistModalCancel, #wishlistModalCross", function () {
    $(".wishlistModal").toggleClass('d-none');
    $(".modalBody").show();
    $(".loginCtn").hide();
});


$('#wishlistModal .nav-tabs a').on('click', function (e) {
    e.preventDefault();
    $(this).tab('show');

    // Remover la clase active de todas las tab-pane
    $('.tab-pane').removeClass('active');

    // Mostrar el contenido de la pestaña seleccionada
    $('#wishlistModal ' + $(this).attr('href')).addClass('active');
});